import CloseIcon from '@mui/icons-material/Close';
import { alpha, Divider, styled, Theme } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const Footer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  gap: '1rem',
  padding: ' 2.5rem',
  flexDirection: 'column-reverse',
  marginTop: 'auto',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '5.5rem',
  },
});

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  height: ' 100%',
}));

export const Header = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.3rem',
  padding: '1rem 1rem 0 1rem',
}));

export const AlignRowBetween = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '2rem',
}));

export const List = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: 400,
  overflowY: 'auto',
  margin: '1rem',
  gap: '1.5rem',
  borderRadius: '0.75rem',

  '&::-webkit-scrollbar-track': {
    background: theme.palette.secondary.main,
    borderRadius: '0.3125rem',
  },
  '&::-webkit-scrollbar': {
    width: '0.25rem',
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: `${theme.palette.tertiary.light}`,
  },
}));

export const DividerStyled = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.details.light,
  width: '90%',
  margin: '0 auto',
  opacity: 0.5,
}));

export const Item = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '1.5rem',
  color: theme.palette.common.white,
}));

export const CloseIconStyled = styled(CloseIcon)(({ theme }) => ({
  alignSelf: 'flex-end',
  cursor: 'pointer',
}));

export const dialogStyles = (theme: Theme) => {
  return {
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    borderRadius: '.4rem',
    width: '100%',
    maxWidth: '37.5rem',
    height: '41.563em',
  };
};
